<template>
	<div class="packaging-view">
		<div class="row" v-for="(pack, i) in packaging" v-bind:key="i">
			<div class="label" :style="{ opacity: (value.hasOwnProperty(pack.id) ? value[pack.id] : '0') == '0' ? '0.4' : '1' }">{{ pack.label }}</div>
			<div class="buttons">
				<div class="orb" @click="dec(pack)">-</div>
				<div class="cnt"><input style="width: 100%; text-align: center;" type="text" :value="value.hasOwnProperty(pack.id) ? value[pack.id] : '0'" @input="set(pack, $event.target.value)" /></div>
				<div class="orb" @click="inc(pack)">+</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				packaging: []
			};
		},
		props: {
			value: {
				type: Object,
				default() {
					return {};
				}
			},
			extended: {
				type: Boolean,
				default: true
			}
		},
		watch: {
			
		},
		methods: {
			set(pack, value) {
				
				var val = {...{}, ...this.value};

				if (isNaN(value) || value < 0) {
					delete val[pack.id];
				} else {
					val[pack.id] = value;
				}

				this.$emit('input', val);
			},
			inc(pack) {
				var val = {...{}, ...this.value};

				if (val.hasOwnProperty(pack.id)) {
					val[pack.id]++;
				} else {
					val[pack.id] = 1;
				}

				this.$emit('input', val);
			},
			dec(pack) {
				var val = {...{}, ...this.value};

				if (val.hasOwnProperty(pack.id)) {
					val[pack.id]--;
				}

				if (val[pack.id] <= 0) {
					delete val[pack.id];
				}

				this.$emit('input', val);
			},
			focus(e) {
				e.target.select();
			}
		},
		computed: {
		
		},
		created() {
			var self = this;

			this.axios
				.get(this.extended ? '/products/deliveries/' : '/products/packaging/')
				.then(function (r) {
					self.packaging = r.data._items;
					//self.$emit('input', []);

			
				});
		}
	}
</script>

<style lang="scss" scoped>
	.packaging-view {
		display: grid;
		grid-template-rows: 20px;
		row-gap: 5px;

		& > .header, & > .row {
			display: grid;
			grid-template-columns: 1fr auto;

			& > div {
				line-height: 20px;
				font-size: 12px;
				text-align: center;
				padding-left: 5px;

				&.in {
					color: #00c017;
				}

				&.out {
					color: #f7223f;
				}

				&:first-child {
					text-align: left;
					padding-left: 0;
				}

				&.buttons {
					& > div {
						display: inline-block;
						line-height: 20px;
						text-align: center;

						&.orb {
							background-color: #f7223f;
							width: 20px;
							height: 20px;
							border-radius: 50%;
							cursor: pointer;
						}

						&.cnt {
							width: 80px;
							padding: 0 10px 0 10px;

							& > input {
								border-radius: 10px;
							}
						}
					}
				}
			}
		}

		& > .header {
			& > div {
				font-weight: bold;
			}
		}

		& > .row {
			& > div {
				& > input {
					width: 100%;
					height: 20px;
					text-align: center;
					background-color: #202127;
					color: white;
					line-height: 20px;
					font-size: 12px;
				}
			}
		}
	}
</style>